<template>
  <div>
    <v-list-item class="px-0">
      <v-list-item-content>
        <div v-if="isView">
          <div class="subtitle-1 font-weight-bold">Data Instansi</div>
        </div>
        <div v-else>
          <div class="subtitle-1 font-weight-bold">Data CV</div>
          <span>
            Lengkapi data persyaratan sesuai kebutuhan sistem, Silakan <b>tekan tombol/icon pensil</b> di sebelah kanan
            untuk melakukan edit.
          </span>
        </div>
      </v-list-item-content>
      <v-list-item-action v-if="!isView">
        <v-btn
          :disabled="!$allow(`${['lpd', 'admin-kelas'].includes(jenis) ? jenis : 'petugas'}-profil.update`)"
          depressed
          color="primary"
          @click="$emit('edit')"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-row class="my-5">
      <v-col cols="12" md="2" sm="12">
        <base-photo-profil
          :photo="$getDeepObj(detail, 'akun.data.foto_url') || $getDeepObj(detail, 'instansi.data.foto_url') || ''"
          :photodef="jenis === 'lpd' ? 'default_foto_lpd.png' : 'default_foto_gp.png'"
          :useBase64="true"
        />
      </v-col>
      <v-col cols="12" md="10" sm="12">
        <v-row>
          <v-col v-for="(profil, p) in profils" :key="p" cols="12" md="12" sm="12">
            <div v-if="p !== 'dasar'" class="text-h6 my-3 black--text font-weight-bold"> Data {{ $titleCase(p) }} </div>
            <v-row>
              <v-col v-for="(sub, s) in profil" :key="s" v-bind="sub.grid">
                <div class="caption">{{ $getDeepObj(sub, 'title') || '-' }}</div>
                <h2 class="subtitle-1 black--text"><span v-html="$getDeepObj(sub, 'value') || '-'" /></h2>
              </v-col>
            </v-row>
          </v-col>
          <!-- Sheet Diklat -->
          <v-col cols="12" md="6" sm="12" v-if="jenis === 'lpd' && !isView">
            <div class="text-h6 my-3 font-weight-bold"> Data Diklat </div>
            <div class="grey--text">Pengalaman Melatih 2 Tahun Terakhir</div>
            <v-list three-line>
              <v-list-item v-for="(item, index) in diklats" :key="index">
                <v-list-item-avatar tile>
                  <v-avatar tile color="primary">
                    <span class="white--text">{{ index + 1 }}</span>
                  </v-avatar>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-html="item.nama"></v-list-item-title>
                  <v-list-item-subtitle v-html="item.tahun"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import BasePhotoProfil from '@components/base/BasePhotoProfil';
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    masters: {
      type: Object,
      default: () => {},
    },
    jenis: {
      type: String,
      default: 'pengajar',
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  components: { BasePhotoProfil },
  computed: {
    diklats() {
      const diklat =
        this.$getDeepObj(this.detail, 'pengalaman') ||
        (this.$getDeepObj(this.detail, 'diklat') &&
          typeof this.$getDeepObj(this.detail, 'diklat') === 'string' &&
          JSON.parse(this.$getDeepObj(this.detail, 'diklat') || '[]')) ||
        this.$getDeepObj(this.detail, 'diklat') ||
        [];
      return diklat;
    },

    profils() {
      const item = Object.assign({}, this.detail);
      console.log(this.masters);
      const profil = {
        pengajar: {
          dasar: [
            {
              title: 'Nama Lengkap',
              value: this.$getDeepObj(item, 'akun.data.nama') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Jenis Kelamin',
              value: this.$fGender(this.$getDeepObj(item, 'akun.data.kelamin')) || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'NIP / NUPTK',
              value: this.$getDeepObj(item, 'akun.data.nip') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Pendidikan Terakhir',
              value:
                (this.$getDeepObj(this, `masters.m_kualifikasi.${this.$getDeepObj(item, 'k_kualifikasi')}`) || '-') +
                ' - ' +
                (this.$getDeepObj(item, 'lulusan') || '-'),
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              title: 'Prodi',
              value: this.$getDeepObj(item, 'prodi') || '-',
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              title: 'NIK',
              value: this.$getDeepObj(item, 'akun.data.nik') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Email',
              value: this.$getDeepObj(item, 'akun.data.email') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Tempat Tanggal Lahir',
              value:
                (this.$getDeepObj(item, 'akun.data.tmp_lahir') || '-') +
                ', ' +
                (this.$localDate(this.$getDeepObj(item, 'akun.data.tgl_lahir')) || '-'),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Nomor HP Aktif',
              value: this.$getDeepObj(item, 'akun.data.no_hp') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Alamat Sesuai KTP',
              value: this.$getDeepObj(item, 'akun.data.alamat') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kota/Kab. dan Provinsi',
              value: [
                this.$getDeepObj(item, 'akun.data.k_kota')
                  ? this.masters.m_kota && this.masters.m_kota[this.$getDeepObj(item, 'akun.data.k_kota')]
                  : '-',
                this.$getDeepObj(item, 'akun.data.k_propinsi')
                  ? this.masters.m_propinsi && this.masters.m_propinsi[this.$getDeepObj(item, 'akun.data.k_propinsi')]
                  : '-',
              ].join(' - '),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kodepos',
              value: this.$getDeepObj(item, 'akun.data.kodepos') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
          instansi: [
            {
              title: 'Instansi',
              value: this.$getDeepObj(item, 'instansi_nama') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Pekerjaan',
              value: this.$getDeepObj(item, 'm_pekerjaan_paud.data.keterangan') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Jabatan',
              value: this.$getDeepObj(item, 'instansi_jabatan') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Alamat Instansi',
              value: this.$getDeepObj(item, 'instansi_alamat') || '-',
              grid: { cols: 12, md: 12, sm: 12 },
            },
            {
              title: 'Kota/Kab. dan Provinsi',
              value: [
                this.$getDeepObj(item, 'instansi_kota.data.keterangan'),
                this.$getDeepObj(item, 'instansi_propinsi.data.keterangan'),
              ].join(' - '),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kodepos',
              value: this.$getDeepObj(item, 'instansi_kodepos'),
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
        },
        pembimbing: {
          dasar: [
            {
              title: 'Nama Lengkap',
              value: this.$getDeepObj(item, 'akun.data.nama') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Jenis Kelamin',
              value: this.$fGender(this.$getDeepObj(item, 'akun.data.kelamin')) || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'NIP / NUPTK',
              value: this.$getDeepObj(item, 'akun.data.nip') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Pendidikan Terakhir',
              value:
                (Number(this.$getDeepObj(item, 'k_kualifikasi') === 3)
                  ? 'SMA Sederajat'
                  : this.$getDeepObj(this, `masters.m_kualifikasi.${this.$getDeepObj(item, 'k_kualifikasi')}`) || '-') +
                ' - ' +
                (this.$getDeepObj(item, 'lulusan') || '-'),
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              title: 'Prodi',
              value: this.$getDeepObj(item, 'prodi') || '-',
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              title: 'NIK',
              value: this.$getDeepObj(item, 'akun.data.nik') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Email',
              value: this.$getDeepObj(item, 'akun.data.email') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Tempat Tanggal Lahir',
              value:
                (this.$getDeepObj(item, 'akun.data.tmp_lahir') || '-') +
                ', ' +
                (this.$localDate(this.$getDeepObj(item, 'akun.data.tgl_lahir')) || '-'),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Nomor HP Aktif',
              value: this.$getDeepObj(item, 'akun.data.no_hp') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Alamat Sesuai KTP',
              value: this.$getDeepObj(item, 'akun.data.alamat') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kota/Kab. dan Provinsi',
              value: [
                this.$getDeepObj(item, 'akun.data.k_kota')
                  ? this.masters.m_kota && this.masters.m_kota[this.$getDeepObj(item, 'akun.data.k_kota')]
                  : '-',
                this.$getDeepObj(item, 'akun.data.k_propinsi')
                  ? this.masters.m_propinsi && this.masters.m_propinsi[this.$getDeepObj(item, 'akun.data.k_propinsi')]
                  : '-',
              ].join(' - '),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kodepos',
              value: this.$getDeepObj(item, 'akun.data.kodepos') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
          instansi: [
            {
              title: 'Instansi',
              value: this.$getDeepObj(item, 'instansi_nama') || '-',
              grid: { cols: 12, md: 12, sm: 12 },
            },
            {
              title: 'Pekerjaan',
              value: this.$getDeepObj(item, 'm_pekerjaan_paud.data.keterangan') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Jabatan',
              value: this.$getDeepObj(item, 'instansi_jabatan') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Alamat Instansi',
              value: this.$getDeepObj(item, 'instansi_alamat') || '-',
              grid: { cols: 12, md: 12, sm: 12 },
            },
            {
              title: 'Kota/Kab. dan Provinsi',
              value: [
                this.$getDeepObj(item, 'instansi_k_kota')
                  ? this.masters.m_kota && this.masters.m_kota[this.$getDeepObj(item, 'akun.data.k_kota')]
                  : '-',
                this.$getDeepObj(item, 'instansi_k_propinsi')
                  ? this.masters.m_propinsi && this.masters.m_propinsi[this.$getDeepObj(item, 'instansi_k_propinsi')]
                  : '-',
              ].join(' - '),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kodepos',
              value: this.$getDeepObj(item, 'instansi_kodepos') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
        },
        'admin-kelas': {
          dasar: [
            {
              title: 'Nama Lengkap',
              value: this.$getDeepObj(item, 'akun.data.nama') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Jenis Kelamin',
              value: this.$fGender(this.$getDeepObj(item, 'akun.data.kelamin')) || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'NIK',
              value: this.$getDeepObj(item, 'akun.data.nik') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Email',
              value: this.$getDeepObj(item, 'akun.data.email') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Tempat, Tanggal Lahir',
              value:
                (this.$getDeepObj(item, 'akun.data.tmp_lahir') || '-') +
                ', ' +
                (this.$localDate(this.$getDeepObj(item, 'akun.data.tgl_lahir')) || '-'),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Nomor HP Aktif',
              value: this.$getDeepObj(item, 'akun.data.no_hp') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Alamat Sesuai KTP',
              value: this.$getDeepObj(item, 'akun.data.alamat') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kota/Kab. dan Provinsi',
              value: [
                this.$getDeepObj(item, 'akun.data.k_kota')
                  ? this.masters.m_kota && this.masters.m_kota[this.$getDeepObj(item, 'akun.data.k_kota')]
                  : '-',
                this.$getDeepObj(item, 'akun.data.k_propinsi')
                  ? this.masters.m_propinsi && this.masters.m_propinsi[this.$getDeepObj(item, 'akun.data.k_propinsi')]
                  : '-',
              ].join(' - '),
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              title: 'Kodepos',
              value: this.$getDeepObj(item, 'akun.data.kodepos') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
        },
        lpd: this.isView
          ? {
              dasar: [
                {
                  title: 'Nama Institusi',
                  value: this.$getDeepObj(item, 'instansi.data.nama') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Alamat Surel',
                  value: this.$getDeepObj(item, 'instansi.data.email') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Alamat',
                  value: this.$getDeepObj(item, 'instansi.data.alamat') || '-',
                  grid: { cols: 12, md: 12, sm: 12 },
                },
                {
                  title: 'Provinsi',
                  value: this.$getDeepObj(item, 'instansi.data.m_propinsi.data.keterangan') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Kota/Kabupaten',
                  value: this.$getDeepObj(item, 'instansi.data.m_kota.data.keterangan') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Kode Pos',
                  value: this.$getDeepObj(item, 'kodepos') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Penanggung Jawab LPD / Kepala B/BGP',
                  value: this.$getDeepObj(item, 'nama_penanggung_jawab') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'No. Telpon (Penanggung Jawab LPD / Kepala B/BGP)',
                  value: this.$getDeepObj(item, 'telp_penanggung_jawab') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Level LPD',
                  value: this.$getDeepObj(this.masters, `m_lpd_paud.${item.k_lpd_paud}`),
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Status UPT',
                  value: item.is_utp === 1 ? 'LPD Dari UPT' : 'LPD Non UPT',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
              ],
              petugas: [
                {
                  title: 'Persentase Pengajar Tambahan',
                  value: (this.$getDeepObj(item, 'ratio_pengajar_tambahan') || '-') + '%',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
              ],
            }
          : {
              dasar: [
                {
                  title: 'Nama Lembaga',
                  value: this.$getDeepObj(item, 'instansi.data.nama') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Alamat Lembaga',
                  value: this.$getDeepObj(item, 'instansi.data.alamat') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Email',
                  value: this.$getDeepObj(item, 'instansi.data.email') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Propinsi',
                  value: this.$getDeepObj(item, 'instansi.data.m_propinsi.data.keterangan') || '-',
                  grid: { cols: 12, md: 3, sm: 12 },
                },
                {
                  title: 'Kabupaten/Kota',
                  value: this.$getDeepObj(item, 'instansi.data.m_kota.data.keterangan') || '-',
                  grid: { cols: 12, md: 3, sm: 12 },
                },
                {
                  title: 'Nomor Telepon',
                  value: this.$getDeepObj(item, 'instansi.data.no_telpon') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
                {
                  title: 'Kodepos',
                  value: this.$getDeepObj(item, 'kodepos') || '-',
                  grid: { cols: 12, md: 6, sm: 12 },
                },
              ],
              tambahan: [
                {
                  title: 'Penanggung Jawab LPD / Kepala B/BGP',
                  value:
                    (this.$getDeepObj(item, 'nama_penanggung_jawab') || '-') +
                    '<br/>' +
                    (this.$getDeepObj(item, 'telp_penanggung_jawab') || '-'),
                  grid: { cols: 12, md: 12, sm: 12 },
                },
                {
                  title: 'Sekertaris',
                  value:
                    (this.$getDeepObj(item, 'nama_sekretaris') || '-') +
                    '<br/>' +
                    (this.$getDeepObj(item, 'telp_sekretaris') || '-'),
                  grid: { cols: 12, md: 12, sm: 12 },
                },
                {
                  title: 'Bendahara',
                  value:
                    (this.$getDeepObj(item, 'nama_bendahara') || '-') +
                    ' <br/>' +
                    (this.$getDeepObj(item, 'telp_bendahara') || '-'),
                  grid: { cols: 12, md: 12, sm: 12 },
                },
              ],
            },
      };

      return profil[this.jenis];
    },
  },
};
</script>
